import { OrderStatusEnum } from "@src/features/order/entities";

export const OrderDetailsStatusColors: Record<OrderStatusEnum, string> = {
  [OrderStatusEnum.NEW]: "info.main",
  [OrderStatusEnum.ASSIGNED]: "ghost.main",
  [OrderStatusEnum.READY_FOR_TAKE_OFF]: "warning.main",
  [OrderStatusEnum.EN_ROUTE]: "success.main",
  [OrderStatusEnum.COMPLETED]: "brand.main",
  [OrderStatusEnum.CANCELLED]: "ghost.main",
  [OrderStatusEnum.ERROR]: "error.main",
  [OrderStatusEnum.IN_FLIGHT]: "info.main",
};
